<template>
  <RecruitmentBase color="grey" :overlay-activated="false" :hide-expiration="true" :show-details-link="false" :loading-animation="true">
    <template #header>
      <QSkeleton animation="blink" type="text" width="50px" />
    </template>
    <template #subtitle>
      <QSkeleton animation="blink" type="text" width="100px" class="text-subtitle1" />
      <QSkeleton animation="blink" type="text" width="150px" />
    </template>
    <template #footer>
      <p>
        <QIcon class="q-skeleton--anim-blink" name="icon-f-clock" />
        <QSkeleton animation="blink" type="text" width="150px" />
      </p>
    </template>
  </RecruitmentBase>
</template>

<script>
  import RecruitmentBase from "@etab/components/dashboard/recruitment/RecruitmentBase.component.vue";

  export default {
    components: {
      RecruitmentBase,
    },
  };
</script>
